import { Button } from "./Elements";
import Modal from "./Modal";


const PackageErrorModal = ({ errorMessage, isVisible, setIsVisible, packageErrorText }) => {




  return (
    <Modal openModal={isVisible} setOpenModal={setIsVisible}>
      <div>
        <div className="sm:flex sm:items-start">
          <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3 className="text-md leading-6 font-medium text-gray-900">
              {packageErrorText} Paketiniz Tükenmiştir
            </h3>
            <div className="mt-6">
              <div className="flex">
                <img
                  className="text-error h-10 w-10"
                  src="/icons/basarisiz.svg"
                  alt="error"
                />
                <p className="text-sm text-gray-500">
                  {errorMessage || `Ödeme linki oluşturmak için ${packageErrorText} paketi satın almanız gerekmektedir.`}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5 mt-6 sm:flex justify-end space-x-2 flex">
          <Button

            color="gray"
            hover="gray"
            size="xs"
            callback={() => setIsVisible(false)}
          >
            İptal
          </Button>
          <Button
            color="primary"
            hover="primary"
            size="xs"
            callback={() => {
              setIsVisible(false)
              window.open("https://siparis.elogo.com.tr/", "_blank")
            }}
          >
            Sipariş Portalına Gidin
          </Button>
        </div>
      </div>
    </Modal>
  );
}
export default PackageErrorModal;